(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidekit-kit-farofa"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sidekit-builder')) {
    class SidekitBuilder extends HTMLElement {
      connectedCallback() {
        this.flavors = [...this.querySelectorAll('[data-sidekit-flavor]')];
        this.tiers = [...this.querySelectorAll('[data-sidekit-tier]')]
          .map((element) => ({
            element,
            size: Number(element.dataset.size),
            unitPrice: Number(element.dataset.unitPrice),
          }))
          .sort((a, b) => a.size - b.size);
        this.quantities = new Map(this.flavors.map((flavor) => [flavor.dataset.blockId, 0]));
        this.minQuantity = Number(this.dataset.minQuantity);
        this.maxQuantity = Number(this.dataset.maxQuantity);
        this.compareUnitPrice = Number(this.dataset.compareUnitPrice);
        this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency: Shopify.currency.active,
        });
        this.abortController = new AbortController();
        this.#randomizeSocialProof();
        this.#bindEvents();
        this.#render();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      #randomizeSocialProof() {
        if (this.dataset.randomizeSocialProof !== 'true') return;
        const socialProof = this.querySelector('[data-sidekit-social-proof]');
        if (!socialProof) return;

        const minimum = Number(this.dataset.socialProofMin);
        const maximum = Number(this.dataset.socialProofMax);
        const lower = Math.min(minimum, maximum);
        const upper = Math.max(minimum, maximum);
        const value = Math.floor(Math.random() * (upper - lower + 1)) + lower;
        const formattedValue = `+${value.toLocaleString(document.documentElement.lang || 'pt-BR')}`;
        socialProof.textContent = socialProof.textContent.replace(/\+?[\d.,]+/, formattedValue);
        socialProof.removeAttribute('data-sidekit-random-pending');
      }

      #bindEvents() {
        const signal = this.abortController.signal;

        for (const thumb of this.querySelectorAll('[data-sidekit-thumb]')) {
          thumb.addEventListener('click', () => this.#selectImage(thumb), { signal });
        }

        for (const flavor of this.flavors) {
          flavor.querySelector('[data-sidekit-decrease]')?.addEventListener(
            'click',
            () => this.#changeQuantity(flavor, -1),
            { signal }
          );
          flavor.querySelector('[data-sidekit-increase]')?.addEventListener(
            'click',
            () => this.#changeQuantity(flavor, 1),
            { signal }
          );
        }

        this.querySelector('[data-sidekit-submit]')?.addEventListener(
          'click',
          () => this.#addToCart(),
          { signal }
        );

        const shippingForm = this.querySelector('[data-sidekit-shipping-form]');
        shippingForm?.addEventListener('submit', (event) => this.#validateCep(event), { signal });
        this.querySelector('[data-sidekit-cep]')?.addEventListener('input', (event) => {
          const digits = event.target.value.replace(/\D/g, '').slice(0, 8);
          event.target.value = digits.replace(/^(\d{5})(\d)/, '$1-$2');
          this.#setShippingFeedback(this.dataset.labelCepHelp, false);
        }, { signal });
      }

      #selectImage(thumb) {
        const hero = this.querySelector('[data-sidekit-hero]');
        if (!hero || !thumb.dataset.image) return;
        hero.src = thumb.dataset.image;
        hero.srcset = '';
        hero.alt = thumb.dataset.alt;
        for (const item of this.querySelectorAll('[data-sidekit-thumb]')) {
          const active = item === thumb;
          item.classList.toggle('sidekit__thumb--active', active);
          item.setAttribute('aria-pressed', String(active));
        }
      }

      #changeQuantity(flavor, change) {
        const id = flavor.dataset.blockId;
        const current = this.quantities.get(id) || 0;
        const total = this.#totalQuantity();
        if (change > 0 && total >= this.maxQuantity) return;
        if (change < 0 && current <= 0) return;
        this.quantities.set(id, current + change);
        const matchingThumb = this.querySelector(`[data-sidekit-thumb][data-block-id="${CSS.escape(id)}"]`);
        if (matchingThumb && change > 0) this.#selectImage(matchingThumb);
        this.#render();
      }

      #totalQuantity() {
        let total = 0;
        for (const quantity of this.quantities.values()) total += quantity;
        return total;
      }

      #currentTier(total) {
        let current = this.tiers[0] || null;
        for (const tier of this.tiers) {
          if (total >= tier.size) current = tier;
        }
        return current;
      }

      #actualProductsTotal() {
        let total = 0;
        for (const flavor of this.flavors) {
          total += Number(flavor.dataset.productPrice) * (this.quantities.get(flavor.dataset.blockId) || 0);
        }
        return total;
      }

      #render() {
        const total = this.#totalQuantity();
        const tier = this.#currentTier(total);
        const calculatedTotal = tier ? tier.unitPrice * total : this.#actualProductsTotal();
        const compareTotal = this.compareUnitPrice * total;
        const complete = total >= this.minQuantity && total <= this.maxQuantity;

        this.querySelector('[data-sidekit-count]').textContent = String(total);

        const firstTierSize = this.tiers[0]?.size || 0;
        const lastTierSize = this.tiers[this.tiers.length - 1]?.size || this.maxQuantity;
        const tierProgress = total <= firstTierSize
          ? 0
          : Math.min(100, ((total - firstTierSize) / Math.max(1, lastTierSize - firstTierSize)) * 100);
        const tierFill = this.querySelector('[data-sidekit-tier-fill]');
        if (tierFill) tierFill.style.width = `${tierProgress}%`;

        for (const item of this.tiers) {
          item.element.classList.toggle('sidekit__tier--reached', total >= item.size);
        }

        for (const flavor of this.flavors) {
          const quantity = this.quantities.get(flavor.dataset.blockId) || 0;
          const available = flavor.dataset.available === 'true';
          flavor.classList.toggle('sidekit__flavor--selected', quantity > 0);
          flavor.querySelector('[data-sidekit-quantity]').textContent = String(quantity);
          flavor.querySelector('[data-sidekit-decrease]').disabled = quantity === 0;
          flavor.querySelector('[data-sidekit-increase]').disabled = !available || total >= this.maxQuantity;

          const badge = this.querySelector(
            `[data-sidekit-thumb][data-block-id="${CSS.escape(flavor.dataset.blockId)}"] [data-sidekit-thumb-quantity]`
          );
          if (badge) {
            badge.textContent = String(quantity);
            badge.hidden = quantity === 0;
          }
        }

        this.querySelector('[data-sidekit-total]').textContent = this.#formatMoney(calculatedTotal);
        const compare = this.querySelector('[data-sidekit-compare]');
        const saving = this.querySelector('[data-sidekit-saving]');
        const hasSaving = total > 0 && compareTotal > calculatedTotal;
        compare.hidden = !hasSaving;
        compare.textContent = hasSaving ? this.#formatMoney(compareTotal) : '';
        saving.textContent = hasSaving
          ? `${this.dataset.labelSelected} ${this.#formatMoney(compareTotal - calculatedTotal)}`
          : '';

        const submit = this.querySelector('[data-sidekit-submit]');
        submit.disabled = !complete;
        this.querySelector('[data-sidekit-submit-label]').textContent =
          complete ? this.dataset.labelAdd : this.dataset.labelIncomplete;
      }

      #formatMoney(cents) {
        return this.moneyFormatter.format(cents / 100);
      }

      async #addToCart() {
        const submit = this.querySelector('[data-sidekit-submit]');
        const label = this.querySelector('[data-sidekit-submit-label]');
        const status = this.querySelector('[data-sidekit-status]');
        const items = this.flavors
          .map((flavor) => ({
            id: Number(flavor.dataset.variantId),
            quantity: this.quantities.get(flavor.dataset.blockId) || 0,
          }))
          .filter((item) => item.id && item.quantity > 0);

        if (!items.length) return;
        submit.disabled = true;
        label.textContent = this.dataset.labelAdding;
        status.textContent = '';

        try {
          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (this.dataset.redirectToCart === 'true') {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          status.textContent = this.dataset.labelAdd;
        } catch (error) {
          console.error('SIDEKIT cart error', error);
          status.textContent = this.dataset.labelError;
        } finally {
          label.textContent = this.dataset.labelAdd;
          submit.disabled = false;
        }
      }

      #validateCep(event) {
        event.preventDefault();
        const input = this.querySelector('[data-sidekit-cep]');
        const valid = input.value.replace(/\D/g, '').length === 8;
        this.#setShippingFeedback(
          valid ? this.dataset.labelValidCep : this.dataset.labelInvalidCep,
          !valid
        );
        if (!valid) input.focus();
      }

      #setShippingFeedback(message, error) {
        const shipping = this.querySelector('[data-sidekit-shipping]');
        const feedback = this.querySelector('[data-sidekit-shipping-feedback]');
        if (!shipping || !feedback) return;
        shipping.classList.toggle('sidekit__shipping--error', error);
        feedback.textContent = message;
      }
    }

    customElements.define('sidekit-builder', SidekitBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
